import React, { forwardRef, useEffect } from 'react';
import configData from '../../../temp/config'

const Customdatepicker = (props, ref) => {
    return(
        <button className="example-custom-input datepicker" type="button" onClick={props.onClick}>
            <span className={props.value.length === 0 ? 'placeholder' : ''}>
                {
                    props.value.length === 0 ? props.placeholder : props.value
                }
            </span>
            <img src={`${configData.sitecoreApiHost}${props.imagepath.src}`} alt={props.imagepath.alt} />
        </button>
    )
};

export default forwardRef(Customdatepicker);